// import stageConfig from '@/config/stage' // 引入舞台配置
// import AppConfig from '@/config/index' // 引入项目配置

export default {
  logined: false, // 是否登录
  user: {}, // 当前用户
  // 当前页信息
  currentRoute: {
    config: null,
    treePath: []
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js